import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from "../customFetchBase";

export const servicesApi = createApi({
  reducerPath: "servicesApi",
  baseQuery: customFetchBase({ url: "services" }),
  endpoints: (builder) => ({
    getServices: builder.query({
      query: ({ page = 1, search, code } = {}) => {
        let url = `?no_of_docs_each_page=25&page=${page}`;
        if (search) url += `&search=${search}`;
        if (code) url += `&code=${code}`;
        return {
          url,
          method: "GET",
        };
      },
    }),
  }),
});
export const { useGetServicesQuery } = servicesApi;
